import moment from "moment";
import {
  GET_CONTACT_US,
  SET_PAGE,
  SET_SEARCH,
} from "../../shared/constants/ActionTypes";

const initialContactUs = {
  contactUs: [],
  contactUsCount: 0,
  page: 1,
  search: "",
};

const contactUsReducer = (state = initialContactUs, action) => {
  switch (action.type) {
    case GET_CONTACT_US:
      return {
        ...state,
        contactUs: action.payload?.contacUsList?.map((item) => {
          return {
            ...item,
            name: item?.name,
            updatedAtFormatted: moment(item?.createdAt).format("ll"),
          };
        }),
        contactUsCount: action.payload?.total,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };

    default:
      return state;
  }
};

export default contactUsReducer;
